export function filterOrganisations({ state, props }) {
  const organisations = state.get(
    'admin.campaigns.create.config.organisations'
  );
  const organisation = state.get(
    'admin.campaigns.create.config.form.organisation.value'
  );
  const formValue = props.value;
  const filteredOrganisations = {};

  Object.keys(organisations).forEach(orgKey => {
    if (organisations[orgKey].name.indexOf(formValue) !== -1) {
      filteredOrganisations[orgKey] = organisations[orgKey];
      if (organisation && organisation === filteredOrganisations[orgKey].name) {
        state.set('admin.campaigns.create.config.organisationKey', orgKey);
      }
    }
  });

  state.set(
    'admin.campaigns.create.config.filteredOrganisations',
    filteredOrganisations
  );
}
